module.exports = __webpack_public_path__ + "media/images/pc/top/recommend_plan_maedori-b51ae4393e6348876a4d7adcd1e79683.webp";